import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { FC } from 'react';
import { RadioButton, RadioButtonProps } from './RadioButton';
import { cn } from '@fe-learner-common';

interface RadioGroupProps extends Omit<RadioButtonProps, 'value'> {
  items: { key: string; label: string }[];
  ariaLabel: string;
  selected: string;
  onValueChange: (value: string) => void;
}

export const RadioButtonGroup: FC<RadioGroupProps> = ({
  id,
  size,
  items,
  ariaLabel,
  selected,
  onValueChange,
}) => {
  const handleOnChange = (value: string) => {
    if (value !== selected) {
      onValueChange(value);
    }
  };

  return (
    <RadioGroupPrimitive.Root
      className="flex flex-col"
      defaultValue={selected}
      value={selected}
      aria-label={ariaLabel}
      onValueChange={onValueChange}
    >
      {items.map((item) => {
        const itemId = `radio-button-${id}-option-${item.key}`;
        return (
          <div
            onClick={() => handleOnChange(item.key)}
            key={itemId}
            className="flex h-12 cursor-pointer items-center gap-2 rounded-lg p-3.5 pe-3 hover:bg-neutral-100"
          >
            <RadioButton value={item.key} size={size} id={itemId} />
            <label
              onClick={(e) => e.preventDefault()}
              className={cn('cursor-pointer text-title-sm leading-none', {
                'text-neutral-500': selected !== item.key,
              })}
              htmlFor={itemId}
            >
              {item.label}
            </label>
          </div>
        );
      })}
    </RadioGroupPrimitive.Root>
  );
};
